import React from 'react';
import { OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { useTranslation } from 'react-i18next';

const SettingsForm: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <OpForm.Input
        name="name"
        label={t('emailTemplates.form.templateName')}
        rules={[{ required: true, message: t('emailTemplates.form.templateNameRequired') }]}
      />
      <OpForm.Input
        name="description"
        label={t('emailTemplates.form.description')}
      />
    </>
  );
};

export default SettingsForm;
